






































import Vue from "vue";
export default Vue.extend({
  beforeCreate(): void {
    this.$store.commit("initialize");
  },
  methods: {
    isLoggedIn(): boolean {
      return this.$store.state.currentUser.loggedIn;
    },
    logout(): void {
      this.$store.commit("clearUser");
    }
  }
});
